import { Observable, ReplaySubject } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class LazyLoadingService {
  _loadedLibraries: { [url: string]: ReplaySubject<any> } = {};

  constructor(@Inject(DOCUMENT) private readonly document: any) {
  }

  loadScript(url: string, integrity?: string): Observable<any> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    // script.integrity = integrity;
    script.crossorigin = 'anonymous';
    script.onload = () => {
      this._loadedLibraries[url].next();
      this._loadedLibraries[url].complete();
    };

    this.document.body.appendChild(script);

    return this._loadedLibraries[url].asObservable();
  }

  loadStyle(url: string, integrity?: string): Observable<any> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const link = this.document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    // link.integrity = integrity;
    link.crossorigin = 'anonymous';
    link.onload = () => {
      this._loadedLibraries[url].next();
      this._loadedLibraries[url].complete();
    };
    link.onerror = (e) => {
      console.log(e);
    };

    this.document.body.appendChild(link);

    return this._loadedLibraries[url].asObservable();
  }
}
